// Función para inicializar Google Analytics
export const initGA = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-NLK83FVT0K'); // Reemplazar con tu ID de Google Analytics
};

// Función para enviar eventos
export const logEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Eventos específicos para el formulario de inscripción
export const InscriptionEvents = {
  FORM_START: 'form_start',
  FORM_SUBMIT_ATTEMPT: 'form_submit_attempt',
  FORM_COMPLETE: 'form_complete',
  FORM_ERROR: 'form_error',
  EMAIL_CONFIRMATION_SENT: 'email_confirmation_sent',
  EMAIL_CONFIRMATION_RESENT: 'email_confirmation_resent',
  EMAIL_CONFIRMATION_SUCCESS: 'email_confirmation_success',
  EMAIL_CONFIRMATION_ERROR: 'email_confirmation_error',
  NOTIFICATION_SENT: 'notification_sent',
  NOTIFICATION_ERROR: 'notification_error'
}; 